module.exports = __webpack_public_path__ + "img/bikkurapon_icon_cn.80887702.png";